
export const SEARCH_PARAMETER = 'src/components/Scorecard/Search/action/Search_Parameter';
export const SELECTED_OPTION = 'src/components/Scorecard/Search/actionSelected_Option';
export const setSearchParameter = (data) => {
    return {
        type: SEARCH_PARAMETER,
        data
    }
}
export const setSelectedOption = (data) => {
    return {
        type: SELECTED_OPTION,
        data
    }
}


export const SEARCH_RESULTS_SUCCESS = 'src/components/Scorecard/Search/action/Search_Results';
export const SEARCH_RESULTS_FAILURE = 'src/components/Scorecard/Search/action/Search_Results_Failure'
export const searchResults = (data) => {
    return {
        type: SEARCH_RESULTS_SUCCESS,
        data
    }
}
export const seacrhResultsFailure = (error) => {
    return {
        type: SEARCH_RESULTS_FAILURE,
        error
    }
}

export const SEARCH_SECTION_TEMPLATE = 'src/components/SectionTemplate/Search/Search_Section_Template'
export const SEARCH_SECTIONTEMPLATE_RESULTS = 'src/components/SectionTemplate/Search/Search_Section_Template_Results'
export const setSectionTemplateSearchParameter = (data) => {
    return {
        type: SEARCH_SECTION_TEMPLATE,
        data
    }
}
export const sectionTemplateSearchResults = (data) => {
    return {
        type: SEARCH_SECTIONTEMPLATE_RESULTS,
        data
    }
}

export const SEARCH_RISK_FACTORS = 'src/components/RiskFactors/Search/Search_Risk_Factors';
export const SEARCH_RISK_FACTORS_RESULTS = 'src/components/RiskFactors/Search/Search_Risk_Factors_Results';

export const setRiskFactorSearchParameter = (data) => {
    return {
        type: SEARCH_RISK_FACTORS,
        data
    }
}
export const setRiskFactorSearchResults = (data) => {
    return {
        type: SEARCH_RISK_FACTORS_RESULTS,
        data
    }
}
export const OVERRIDDING_RISKFACTOR_SEARCH = 'src/components/RiskFactors/Search/Search_Overridding_RiskFactors';
export const SEARCH_OVERRIDDING_RISKFACTORS_RESULTS = 'src/components/RiskFactors/Search/Search_Overridding_RiskFactors_Search_Results';
export const setOverriddingRiskFactorSearchParameter = (data) => {
    return {
        type: OVERRIDDING_RISKFACTOR_SEARCH,
        data
    }
}

export const SCORECARD_SEARCH = 'src/components/RiskFactors/Search/Search_Scorecard';
export const setScorecardSearchParameters = (data) => {
    return {
        type: SCORECARD_SEARCH,
        data
    }
}

export const COUNTRY_AUTOCOMPLETE = 'src/components/ReusableComponents/action/Country_Autocomplete';

export const countryAutoComplete = (data) => {
    return {
        type: COUNTRY_AUTOCOMPLETE,
        data
    }
}



export const STATE_AUTOCOMPLETE = 'src/components/ReusableComponents/action/State_Autocomplete';

export const stateAutoComplete = (data) => {
    return {
        type: STATE_AUTOCOMPLETE,
        data
    }
}


